import { services as auth } from '@/modules/auth'
import { services as home } from '@/pages/home'
import { services as product_car_list } from '@/pages/product_car_list'
import { services as product_list } from '@/pages/product_list'
import { services as product_detail } from '@/pages/product_detail'
import { services as pre_cart } from '@/pages/pre_cart'
import { services as add_car } from '@/pages/add_car'
import { services as cart_checkout } from '@/pages/cart_checkout'
import { services as acompanhar_pedido } from '@/pages/acompanhar_pedido'
import { services as register } from '@/pages/register'


export default {
  auth,
  home,
  product_car_list,
  product_list,
  product_detail,
  pre_cart,
  add_car,
  cart_checkout,
  acompanhar_pedido,
  register,

}
